import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'ps-design';
import './SlideoutError.scss';

const propTypes = {
  className: PropTypes.string,
  doClose: PropTypes.func.isRequired
};

const SlideoutError = props => {
  return (
    <div className={'slideout-error' + (props.className ? ` ${props.className}` : '')}>
      <Alert message={<div>{props.children}</div>} onClickClose={props.doClose} close={true} />
    </div>
  );
};

SlideoutError.propTypes = propTypes;
export default SlideoutError;
